<ws-ace-loader [show]="loading" [size]="4" [hasOverlay]="false"></ws-ace-loader>
@if (availableFeedSpecs) {
    <div style="margin-top: 15px;">
        <div style="margin-bottom: 15px; display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 15px;">
                <div style="white-space: nowrap; min-width: 118px; font-weight: bold;">Client Abbreviation:</div>
                <input type="text"
                       maxlength="50"
                       [(ngModel)]="clientAbbreviation"
                       (change)="clientAbbreviationChange.emit(clientAbbreviation)"
                       class="form-control"
                       [disabled]="!editMode"
                       data-qa="feed-specs-client-abbreviation">
            </div>
            <div style="display: flex; align-items: center; gap: 15px;">
                <div style="white-space: nowrap; min-width: 118px; font-weight: bold;">Data Hub Enabled:</div>
                <div>{{ dataHubEnabled ? 'Yes' : 'No' }}</div>
            </div>
        </div>
        @if (!feedSpecifications) {
            <div class="text-center text-muted">
                <em>Click to Add Feed Specifications</em>
            </div>
        }
        <div style="max-height: 400px; overflow: auto; margin-bottom: 20px;">
            @if (feedSpecifications) {
                <table class="table">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th class="text-center">Included in Email</th>
                        @if (isBillPay) {
                            <th>Feed Applicability</th>
                        }
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        @for (spec of feedSpecifications; track spec; let i = $index) {
                            <tr (mouseenter)="hoveredSpecId = spec.feedSpecificationID" (mouseleave)="hoveredSpecId = null">
                                <td style="white-space: nowrap;">{{ spec.feedSpecification.name }}</td>
                                <td class="text-center">
                                    <div class="checkbox" style="margin: 0;">
                                        <label>
                                            <input type="checkbox"
                                                   [(ngModel)]="spec.includedInEmail"
                                                   [disabled]="!editMode"
                                                   [attr.data-qa]="'feed-specs-included-in-email-' + i">
                                        </label>
                                    </div>
                                </td>
                                @if (isBillPay) {
                                    <td>
                                        {{ getFeedApplicability(spec) }}
                                    </td>
                                }
                                <td>
                                    <button class="ace-btn btn-primary btn-danger has-icon"
                                            [ngClass]="{'invisible': !editMode || hoveredSpecId !== spec.feedSpecificationID}"
                                            (click)="removeSpec(spec)"
                                            [attr.data-qa]="'feed-specs-remove-spec-' + i">
                                        <i class="fa fa-trash" ng-click="vm.removeSpec(spec)"></i>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
        @if (editMode) {
            <ws-select
                placeholder="Add Specification"
                [(ngModel)]="chosenSpec"
                (selectedOptionChanged)="addSpec()"
                [options]="availableFeedSpecs"
                labelProperty="name"
                [returnEntireOption]="true"
                data-qa="feed-specs-add-spec">
            </ws-select>
        }
    </div>
}
